import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-menu.css';

var getClassNameList = classNames.bind(styles);
var UitkMenuTriggerAnalyticsId;
(function (UitkMenuTriggerAnalyticsId) {
    UitkMenuTriggerAnalyticsId["EXPAND"] = "Expand";
    UitkMenuTriggerAnalyticsId["COLLAPSE"] = "Collapse";
})(UitkMenuTriggerAnalyticsId || (UitkMenuTriggerAnalyticsId = {}));
var UitkMenuTrigger = /** @class */ (function (_super) {
    __extends(UitkMenuTrigger, _super);
    function UitkMenuTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMenuTrigger.prototype.render = function () {
        var _a = this.props, mounted = _a.mounted, isOpen = _a.isOpen, children = _a.children, menuId = _a.menuId, onClick = _a.onClick;
        var localAnalyticsId = isOpen ? UitkMenuTriggerAnalyticsId.COLLAPSE : UitkMenuTriggerAnalyticsId.EXPAND;
        var childCount = React.Children.count(children);
        if (!children || childCount !== 1) {
            console.warn("UitkMenuTrigger requires exactly one child component. ".concat(childCount, " children found."));
            return null;
        }
        var menuTriggerChild = children;
        var _b = menuTriggerChild.props, className = _b.className, analytics = _b.analytics;
        var cssClassNames = getClassNameList(UitkMenuTrigger.baseClassName, className);
        var additionalProps = {};
        if (!mounted) {
            var menuIdNoJs = menuId ? "-".concat(menuId) : '';
            additionalProps = {
                'aria-hidden': 'true',
                className: cssClassNames,
                htmlFor: "uitk-menu-no-js".concat(menuIdNoJs),
                tag: 'label'
            };
            return React.cloneElement(menuTriggerChild, additionalProps);
        }
        additionalProps = {
            analytics: analytics ? __assign({ localAnalyticsId: localAnalyticsId }, analytics) : undefined,
            'aria-expanded': isOpen,
            className: cssClassNames,
            onClick: function (e) {
                if (onClick) {
                    onClick(e, { menuId: menuId });
                }
                if (menuTriggerChild.props.onClick) {
                    menuTriggerChild.props.onClick(e, { menuId: menuId });
                }
            }
        };
        return React.cloneElement(menuTriggerChild, additionalProps);
    };
    UitkMenuTrigger.displayName = 'UitkMenuTrigger';
    UitkMenuTrigger.baseClassName = 'uitk-menu-trigger';
    return UitkMenuTrigger;
}(React.Component));

export { UitkMenuTrigger, UitkMenuTriggerAnalyticsId };
